import { render, staticRenderFns } from "./emailMain.vue?vue&type=template&id=2d346fb3&scoped=true&"
import script from "./emailMain.vue?vue&type=script&lang=js&"
export * from "./emailMain.vue?vue&type=script&lang=js&"
import style0 from "./emailMain.vue?vue&type=style&index=0&id=2d346fb3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d346fb3",
  null
  
)

export default component.exports